import {ProductionScheduleStatus} from '@domain/production-schedule/production-schedule-status.enum';
import {OverviewListWeaveProduct} from '@presentation/pages/textile-data/weave-product/overview/overview-list-weave-product';
import {OverviewListWeavingMachine} from './overview-list-weaving-machine';

export class OverviewListProductionOrderWeaving {
  private _id: number;
  private _name: string;
  private _status: ProductionScheduleStatus;
  private _weaveProduct: OverviewListWeaveProduct;
  private _machine: OverviewListWeavingMachine;
  private _plannedLength: number;
  private _dateCreated: Date;
  private _dueDate: Date;
  private _actualStartDate: Date;
  private _actualEndDate: Date;

  public constructor(
    id: number,
    name: string,
    status: ProductionScheduleStatus,
    weaveProduct: OverviewListWeaveProduct,
    machine: OverviewListWeavingMachine,
    plannedLength: number,
    dateCreated: Date,
    dueDate: Date,
    actualStartDate: Date,
    actualEndDate: Date
  ) {
    this._id = id;
    this._name = name;
    this._status = status;
    this._weaveProduct = weaveProduct;
    this._machine = machine;
    this._plannedLength = plannedLength;
    this._dateCreated = dateCreated;
    this._dueDate = dueDate;
    this._actualStartDate = actualStartDate;
    this._actualEndDate = actualEndDate;
  }

  public get id(): number {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get status(): ProductionScheduleStatus {
    return this._status;
  }

  public set status(value: ProductionScheduleStatus) {
    this._status = value;
  }

  public get weaveProduct(): OverviewListWeaveProduct {
    return this._weaveProduct;
  }

  public get machine(): {id: number; name: string} {
    return this._machine;
  }

  public get plannedLength(): number {
    return this._plannedLength;
  }

  public get dateCreated(): Date {
    return this._dateCreated;
  }

  public get dueDate(): Date {
    return this._dueDate;
  }

  public get actualStartDate(): Date {
    return this._actualStartDate;
  }

  public get actualEndDate(): Date {
    return this._actualEndDate;
  }

  public static fromJSON(overviewListWeaveProductionOrderJSON: any): OverviewListProductionOrderWeaving {
    return new OverviewListProductionOrderWeaving(
      overviewListWeaveProductionOrderJSON.id,
      overviewListWeaveProductionOrderJSON.name,
      overviewListWeaveProductionOrderJSON.status,
      OverviewListWeaveProduct.fromJSON(overviewListWeaveProductionOrderJSON.weaveProduct),
      overviewListWeaveProductionOrderJSON.machine ? OverviewListWeavingMachine.fromJSON(overviewListWeaveProductionOrderJSON.machine) : null,
      overviewListWeaveProductionOrderJSON.plannedLength,
      new Date(overviewListWeaveProductionOrderJSON.dateCreated),
      overviewListWeaveProductionOrderJSON.dueDate ? new Date(overviewListWeaveProductionOrderJSON.dueDate) : null,
      overviewListWeaveProductionOrderJSON.actualStartDate ? new Date(overviewListWeaveProductionOrderJSON.actualStartDate) : null,
      overviewListWeaveProductionOrderJSON.actualEndDate ? new Date(overviewListWeaveProductionOrderJSON.actualEndDate) : null
    );
  }

  public canDuplicate(): boolean {
    return true;
  }

  public getReasonForPreventingDuplicate(): string {
    return '';
  }
}
